/* Cookie-consent state, controls and Shopify Customer Privacy synchronization. */
(function () {
  'use strict';

  var STORAGE_KEY = 'verychi_cookie_consent';
  var root = document.querySelector('[data-cookie-consent]');

  if (!root) return;

  function readConsent() {
    try {
      return JSON.parse(window.localStorage.getItem(STORAGE_KEY) || 'null');
    } catch (e) {
      return null;
    }
  }

  function hasConsent() {
    return !!readConsent();
  }

  function publishConsent(value) {
    window.VerychiCookieConsent = value;
    try {
      window.dispatchEvent(new CustomEvent('verychi:cookie-consent', { detail: value }));
    } catch (e) {}
  }

  function saveConsent(value) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
    } catch (e) {}

    if (window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.setTrackingConsent) {
      try {
        Shopify.customerPrivacy.setTrackingConsent({
          analytics: !!value.analytics,
          marketing: !!value.marketing,
          preferences: !!value.preferences,
          sale_of_data: false
        }, function () {});
      } catch (e) {}
    }

    publishConsent(value);
    root.setAttribute('hidden', '');
  }

  var existingConsent = readConsent();
  if (!existingConsent) {
    root.removeAttribute('hidden');
  } else {
    root.setAttribute('hidden', '');
    publishConsent(existingConsent);
  }

  root.addEventListener('click', function (event) {
    if (event.target.closest('[data-cookie-necessary]')) {
      event.preventDefault();
      saveConsent({
        necessary: true,
        preferences: false,
        analytics: false,
        marketing: false
      });
      return;
    }

    if (event.target.closest('[data-cookie-accept]')) {
      event.preventDefault();
      saveConsent({
        necessary: true,
        preferences: true,
        analytics: true,
        marketing: true
      });
      return;
    }
  });
})();
